import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      "For further information on how to become an authorized distributor/retailer, please email us at ",
    reply2:
      " and our dedicated global Sales Team will attend to your enquiry at the soonest possible. If you may, attach your company's information to the email, it would speed up our assistance considerably.",
    reply3:
      "For quick & easy bulk/wholesale purchase in small quantity of up to 60 pieces per order that can enjoy up to 30% price discount, please purchase directly from ",
    reply4: "Amazon Central U.S.",
    back: "Back",
  },
  ja: {
    reply1: "正規代理店/小売店になる方法の詳細については、",
    reply2:
      " まで電子メールでお問い合わせください。当社の専任のグローバル営業チームができるだけ早くお問い合わせに対応いたします。可能であれば、貴社の情報を電子メールに添付していただければ、サポートが大幅に迅速化されます。",
    reply3:
      "最大 30% の価格割引を享受できる、1 注文あたり最大 60 個の少量の大量/卸売購入を迅速かつ簡単に行うには、Amazon Central US から直接購入してください。",
    reply4: "Amazon Central U.S.",
    back: "戻る",
  },
  es: {
    reply1:
      "Para obtener más información sobre cómo convertirse en distribuidor/minorista autorizado, envíenos un correo electrónico a ",
    reply2:
      " y nuestro dedicado equipo de ventas global atenderá su consulta lo antes posible. Si puede adjuntar los datos de su empresa al correo electrónico, agilizará considerablemente nuestra asistencia.",
    reply3:
      "Para una compra rápida y sencilla a granel/al por mayor en pequeñas cantidades de hasta 60 piezas por pedido que pueden disfrutar de hasta un 30 % de descuento en el precio, compre directamente en ",
    reply4: "Amazon Central U.S.",
    back: "Atrás",
  },
});

class Q18_component extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;
    const email = "info@egeetouch.com";
    const mailtoLink = `mailto:${email}`;

    return (
      <div>
        {localizationStrings.reply1}
        <a
          href={mailtoLink}
          style={{ textDecoration: "underline", color: "black" }}
        >
          info@egeetouch.com
        </a>
        {localizationStrings.reply2}
        <br />
        <br />
        {localizationStrings.reply3}
        <a
          href="https://www.amazon.com/eGeeTouch-Travel-Lock-Secure-Luggage-anywhere/dp/B01KK8HPY0/"
          target="_blank"
          style={{ textDecoration: "underline", color: "black" }}
        >
          {localizationStrings.reply4}
        </a>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default Q18_component;
